import React, {useEffect, useState} from 'react';
import _ from 'lodash';
import InformationBox from '../../../../components/other/informationBox';
import {useTranslation} from 'react-i18next';
import Grid from '@mui/material/Grid';
import AgyleTextField from '../../../../components/ui/fields/agyleTextField';
import {SicknessAbsenceCategory} from '../../../../controls/agyle/ecds';
import AgyleDatePicker from '../../../../components/ui/fields/agyleDatePicker';
import moment from 'moment';
import AgyleCheckBox from '../../../../components/ui/checkbox/agyleCheckBox';
import {FormLabel} from '@mui/material';
import config from '../../../../app/config';
import InputAdornment from '@mui/material/InputAdornment';

const EMed3ECDS = (props) => {
    const {t} = useTranslation();
    const [form, setForm] = useState({
        FitNoteAssessmentDate: null,
        FitNoteCondition_SnomedCt: null,
        FitNoteDiagnosis_ICD: '',
        FitNoteStartDate: null,
        FitNoteEndDate: null,
        FitNoteDuration: '',
        FitNoteRecordedDate: null,
        FitNoteFollowUpIndicator: '',
        FitNoteIssuer: '',
    });
    const [found, setFound] = useState(false);

    const updateData = () => {
        const data = {
            ...form,
            FitNoteAssessmentDate: moment(form.FitNoteAssessmentDate).format(config.ecdsDateFormat),
            FitNoteStartDate: moment(form.FitNoteStartDate).format(config.ecdsDateFormat),
            FitNoteEndDate: moment(form.FitNoteEndDate).format(config.ecdsDateFormat),
            FitNoteRecordedDate: moment(form.FitNoteRecordedDate).format(config.ecdsDateFormat),
        };
        props.setData(data);
    };

    useEffect(() => {
        if (props.patient?.studies?.fitnessForWork?.list) {
            const filtered = _.filter(props.patient?.studies?.fitnessForWork?.list, emd => !emd.canceled);
            const first = _.first(filtered);
            if (first) {
                const caseFrom = moment(first?.caseFrom);
                const caseTo = moment(first?.caseTo);
                setForm({
                    FitNoteAssessmentDate: first?.assessedCase ? moment(first.assessedCase) : null,
                    FitNoteCondition_SnomedCt: null, // TODO No data available for this field
                    FitNoteDiagnosis_ICD: '', // TODO No data available for this field
                    FitNoteStartDate: caseFrom,
                    FitNoteEndDate: caseTo,
                    FitNoteDuration: caseTo.diff(caseFrom, 'days'),
                    FitNoteRecordedDate: moment(first?.date),
                    FitNoteFollowUpIndicator: '', // TODO No data available for this field
                    FitNoteIssuer: '', // TODO No data available for this field
                });
                setFound(true);
            }
        }
    }, [props.patient]);

    useEffect(() => {
        const timeoutId = setTimeout(updateData, 400);
        return () => clearTimeout(timeoutId);
    }, [form]);

    const onChange = () => {
    };

    return (
        <>
            {!found &&
                <InformationBox type="info">
                    {t('A eMed3 fit note has not been completed.')}
                </InformationBox>
            }
            {found &&
                <Grid container spacing={2} direction="row" style={{marginTop: 1}}>
                    <Grid item xs={12} md={6}>
                        <AgyleDatePicker
                            label={t('Assessment Date')}
                            type="date"
                            value={form.FitNoteAssessmentDate || null}
                            readOnly
                            onChange={onChange}
                            noBorder={false}
                            withNewBackground
                            size="large"
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <AgyleTextField
                            label={t('Diagnosis (ICD)')}
                            value={form.FitNoteDiagnosis_ICD || ''}
                            readOnly
                            fullWidth
                            noBorder={false}
                            withNewBackground
                            size="large"
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <SicknessAbsenceCategory
                            label={t('Condition')}
                            value={form.FitNoteCondition_SnomedCt || null}
                            readOnly
                            admitDate={props.patient?.admission?.startDate}
                            noBorder={false}
                            withNewBackground
                            size="large"
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <AgyleDatePicker
                            label={t('Start Date')}
                            type="date"
                            value={form.FitNoteStartDate || null}
                            disableFuture={false}
                            readOnly
                            onChange={onChange}
                            noBorder={false}
                            withNewBackground
                            size="large"
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <AgyleDatePicker
                            label={t('End Date')}
                            type="date"
                            value={form.FitNoteEndDate || null}
                            disableFuture={false}
                            readOnly
                            onChange={onChange}
                            noBorder={false}
                            withNewBackground
                            size="large"
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <AgyleTextField
                            label={t('Duration')}
                            value={form.FitNoteDuration || ''}
                            readOnly
                            fullWidth
                            shrink
                            endAdornment={<InputAdornment position="end">{t('Days')}</InputAdornment>}
                            noBorder={false}
                            withNewBackground
                            size="large"
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <AgyleDatePicker
                            label={t('Recorded Date')}
                            type="date"
                            value={form.FitNoteRecordedDate || null}
                            readOnly
                            onChange={onChange}
                            noBorder={false}
                            withNewBackground
                            size="large"
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <AgyleTextField
                            label={t('Issuer')}
                            value={form.FitNoteIssuer || ''}
                            readOnly
                            fullWidth
                            noBorder={false}
                            withNewBackground
                            size="large"
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <FormLabel>
                            {t('Follow Up Assessment Required Indicator')}
                        </FormLabel>
                    </Grid>

                    <Grid item xs={12}>
                        <AgyleCheckBox
                            label={t('Yes - a follow up CARE CONTACT is required at the end of the eMED3 Fit Note Applicable Period')}
                            value={form.FitNoteFollowUpIndicator === 'Y'}
                            disabled
                        />
                        <AgyleCheckBox
                            label={t('No - a follow up CARE CONTACT is not required at the end of the eMED3 Fit Note Applicable Period')}
                            value={form.FitNoteFollowUpIndicator === 'N'}
                            disabled
                        />
                    </Grid>
                </Grid>
            }
        </>
    );
};

export default EMed3ECDS;

